
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers/partner-program/sourcing",
      function () {
        return require("private-next-pages/developers/partner-program/sourcing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers/partner-program/sourcing"])
      });
    }
  